export default __webpack_public_path__ + "static/media/TableDisabled.f56acc66.svg";